export function confirmAssignmentChange(message) {
  return new Promise((resolve) => {
    const dialog = document.createElement("dialog");
    dialog.className = "premium-card w-[calc(100%-2rem)] max-w-md border border-border-subtle bg-background p-5 text-foreground shadow-xl backdrop:bg-black/60";
    dialog.setAttribute("aria-label", "确认配车操作");
    const text = document.createElement("p");
    text.className = "whitespace-pre-wrap text-sm leading-6";
    text.textContent = message;
    const actions = document.createElement("div");
    actions.className = "mt-5 flex justify-end gap-3";
    const cancel = document.createElement("button");
    cancel.type = "button";
    cancel.className = "premium-button bg-muted text-foreground";
    cancel.textContent = "返回，不修改";
    cancel.autofocus = true;
    const confirm = document.createElement("button");
    confirm.type = "button";
    confirm.className = "premium-button bg-destructive text-destructive-foreground";
    confirm.textContent = "确认继续";
    const finish = (accepted) => {
      dialog.close();
      dialog.remove();
      resolve(accepted);
    };
    cancel.onclick = () => finish(false);
    confirm.onclick = () => finish(true);
    dialog.addEventListener("cancel", (event) => {
      event.preventDefault();
      finish(false);
    });
    actions.append(cancel, confirm);
    dialog.append(text, actions);
    document.body.append(dialog);
    dialog.showModal();
  });
}
